import React from 'react'
import { useContextStatistics } from '../../contexts/statisticsContext'
import { formatDate } from '../../utils/date'
import styles from './index.module.css'

const StatisticsCalendarSelection = ({ onShowRange }) => {
    const { statisticsState, removeCalendarRange } = useContextStatistics()

    return (
        <div className={styles.container}>
            {statisticsState.selectedRange.map((range, i) =>
                <div key={i} className={`${range.from && range.hoverTo && styles.calendar}`}>
                    {range.from && range.hoverTo &&
                        <>
                            <button
                                type='button'
                                className={styles['range-text']}
                                title='Show this range in the calendar'
                                onClick={() => onShowRange && onShowRange(range)}
                            >
                                {`From ${formatDate(new Date(range.from), '%d %b %Y')} to
                                ${formatDate(new Date(range.hoverTo), '%d %b %Y')}`}
                            </button>
                            <button
                                type='button'
                                title='Remove this range'
                                aria-label='Remove this range'
                                onClick={() => removeCalendarRange(i)}
                            >
                                ✕
                            </button>
                        </>
                    }
                </div>)
            }
        </div>
    )
}

export default StatisticsCalendarSelection
